import React from 'react';
import ReactDOM from 'react-dom/client';
import { ApolloProvider } from '@apollo/client';
import './index.css';
import App from './App';
import { client } from './graphql/client';
import reportWebVitals from './reportWebVitals';
import { AppThemeProvider } from './theme/ThemeProvider';
import { initMonitoring } from './monitoring/sentry';

initMonitoring();

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  <React.StrictMode>
    <ApolloProvider client={client}>
      <AppThemeProvider>
        <App />
      </AppThemeProvider>
    </ApolloProvider>
  </React.StrictMode>
);

reportWebVitals();
